import { useCallback } from 'react';
import { atom, useRecoilState } from "recoil";

const GlobalLoadingAtom = atom({
    default: false,
    key: "GlobalLoadingAtomewjfoberueqyigpaerjnafvo",
});

export const useGlobalLoading = () => {
    const [loading, setLoading] = useRecoilState(GlobalLoadingAtom);
    const withLoading = useCallback(async (fn) => {
        setLoading(true)
        await fn()
        setLoading(false)
    }, [])
    return [loading, setLoading, withLoading];
};
